import React from 'react'
import { Route, Switch } from 'react-router'
import LoginPage from 'src/page/login'
import PostList from 'src/page/posts/post.list'
import PostCreate from 'src/page/posts/post.create'
import PostEdit from 'src/page/posts/post.edit'
import Dashboard from 'src/page/dashboard/'
import MediaPage from 'src/page/media/media.page'
import Error404 from 'src/page/error404'

import CategoryList from 'src/page/category/category.list'
import TagList from 'src/page/tag/tag.list'

import PennameList from 'src/page/content/penname.list'
import PhotographerList from 'src/page/content/photographer.list'
import VideoList from 'src/page/content/video.list'
import DesignerList from 'src/page/content/designer.list'
import SourceList from 'src/page/content/source.list'
import EditorList from 'src/page/content/editor.list'
import PhotoList from 'src/page/content/photo.list'
import ConfigList from 'src/page/config/config.list'

import UserList from 'src/page/users/user.list'
import UserCreate from 'src/page/users/user.create'
import UserEdit from 'src/page/users/user.edit'
import UserProfile from 'src/page/users/user.profile'
import EditorPage from 'src/page/test/editor/editor-page';
import Homepage from 'src/page/homepage'
import Home from 'src/page/home'
import RoyaltiesList from 'src/page/royalties/royalties.list';
import PreviewPage from 'src/page/preview/page';

import CsvParser from 'src/page/tools/csv.parser'
// import Error404 from 'src/page/error404'
import PublicLayout from 'src/components/layout/public-layout'
import PrivateLayout from 'src/components/layout/private-layout'
import { ToastContainer, toast } from 'react-toastify'
import RealtimePosts from 'src/page/posts-realtime'
import DesignerTools from 'src/page/designer-tools'
import ToolChangeThumbnail from 'src/page/designer-tools/tool-change-thumbnail'
import PostListReviewSEO from '../page/posts/post.review_seo';
import PostCrawledPosts from '../page/posts/post.crawled_posts';

const routeslist = [
  {
    layout: PublicLayout,
    subRoutes: [
      { path: "/login", component: LoginPage },
      { path: "/test/editor", component: EditorPage },
    ]
  },
  {
    layout: PrivateLayout,
    subRoutes: [
      { exact: true, path: "/users", component: UserList },
      { exact: true, path: "/users/new", component: UserCreate },
      { exact: true, path: "/users/edit/:id", component: UserEdit },
      { exact: true, path: "/profile", component: UserProfile },
      { exact: true, path: "/medias", component: MediaPage },
      { exact: true, path: "/posts", component: PostList },
      { exact: true, path: "/videos", component: PostList  },
      { exact: true, path: "/podcasts", component: PostList  },
      { exact: true, path: "/shorts", component: PostList  },
      { exact: true, path: "/posts/new", component: PostCreate },
      { exact: true, path: "/posts/edit/:id", component: PostEdit },
      { exact: true, path: "/tools/import", component: CsvParser },
      // { exact: true, path: "/categories", component: CategoryList },
      // { exact: true, path: "/tags", component: TagList },
      // { exact: true, path: "/content", component: PennameList },
      // { exact: true, path: "/content/pennames", component: PennameList },
      // { exact: true, path: "/content/photographer", component: PhotographerList },
      // { exact: true, path: "/content/video", component: VideoList },
      // { exact: true, path: "/content/designer", component: DesignerList },
      // { exact: true, path: "/content/source", component: SourceList },
      // { exact: true, path: "/content/editor", component: EditorList },
      // { exact: true, path: "/content/photo", component: PhotoList },
      { exact: true, path: "/config", component: ConfigList },
      { exact: true, path: "/homepage", component: Homepage },
      { exact: true, path: "/home", component: Home },
      { exact: true, path: "/nhuan", component: RoyaltiesList },
      { exact: true, path: "/nhuan/chuyen-muc/:cateId", component: RoyaltiesList },
      { exact: true, path: "/nhuan/btv/:royaltiesEditor", component: RoyaltiesList },
      { exact: true, path: "/", component: PostList },
      { exact: true, path: "/ga", component: Dashboard },
      { exact: true, path: "/realtime-posts", component: RealtimePosts},
      { exact: true, path: "/designer-tools", component: DesignerTools},
      { exact: true, path: "/designer-tools/change-thumbnail", component: ToolChangeThumbnail},
      { exact: true, path: "/review-seo", component: PostListReviewSEO},
      { exact: true, path: "/crawled-posts", component: PostCrawledPosts},
      { path: "/preview/:id", component: PreviewPage },
    ]
  },
];

const routes = (
  <Switch>
    {routeslist.map((route, i) =>
      <Route key={i} exact={route.subRoutes.some(r => r.exact)} path={route.subRoutes.map(r => r.path)}>
        <route.layout>
          {route.subRoutes.map((subRoute, i) =>
            <Route key={i} {...subRoute} />
          )}
        </route.layout>

      </Route>
    )}
    <Route path="*" component={Error404} />
  </Switch>
)
export default routes
